// extracted by mini-css-extract-plugin
export var $animation_name = "GermanyHeader-module--$animation_name--9bf46";
export var Block = "GermanyHeader-module--Block--b6342";
export var Block__block = "GermanyHeader-module--Block__block--7637f";
export var Block__block___image = "GermanyHeader-module--Block__block___image--2b330";
export var Block__block___video = "GermanyHeader-module--Block__block___video--e83a3";
export var Block__cover = "GermanyHeader-module--Block__cover--13124";
export var Block__cover___cleared = "GermanyHeader-module--Block__cover___cleared--048e6";
export var Block__innerBlock = "GermanyHeader-module--Block__innerBlock--b3c46";
export var GermanyHeader = "GermanyHeader-module--GermanyHeader--21b22";
export var GermanyHeader___hasBlock = "GermanyHeader-module--GermanyHeader___hasBlock--e3ef0";
export var GermanyHeader___hasNoBlock = "GermanyHeader-module--GermanyHeader___hasNoBlock--e4578";
export var GermanyHeader__black = "GermanyHeader-module--GermanyHeader__black--66a0f";
export var GermanyHeader__blurb = "GermanyHeader-module--GermanyHeader__blurb--0ca24";
export var GermanyHeader__burgundy = "GermanyHeader-module--GermanyHeader__burgundy--48517";
export var GermanyHeader__contentImage = "GermanyHeader-module--GermanyHeader__contentImage--6ba04";
export var GermanyHeader__contentImage2 = "GermanyHeader-module--GermanyHeader__contentImage2--2a00c";
export var GermanyHeader__links = "GermanyHeader-module--GermanyHeader__links--b8fa8";
export var GermanyHeader__navy = "GermanyHeader-module--GermanyHeader__navy--eb099";
export var GermanyHeader__red = "GermanyHeader-module--GermanyHeader__red--5aaeb";
export var GermanyHeader__row = "GermanyHeader-module--GermanyHeader__row--a338d";
export var GermanyHeader__title = "GermanyHeader-module--GermanyHeader__title--8d66f";
export var GermanyHeader__yellow = "GermanyHeader-module--GermanyHeader__yellow--19569";
export var Inner = "GermanyHeader-module--Inner--03cb2";